/**
 * Fake-door test: choosing a local only sends tracking. Nothing is saved.
 * Placeholder speakers stay off in production until this is a real experiment flag.
 */
export const followLocalsFeatureFlags = {
  enabledOutsideProduction: true,
};
